import TopbarSearchButton from './TopbarSearchButton.vue';

export default TopbarSearchButton;
